/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ChannelEventProvider,
  useChannelEventContext,
} from "@/common/provider/ChannelEventSocketProvider";
import { GROUP_ID, MATCH_FORUM_ID, THREAD_ID } from "@/constant/group";
import { useMutationThreads, useThreadQuery } from "@/queries/threads";
import { fetchThread } from "@api/moimAPI";
import { useParams } from "wouter";
import React from "react";
import IFrame from "./iframe";

const MatchPage = () => {
  const { connectTo, disconnect } = useChannelEventContext();
  const params = useParams<{ forumId: string; threadId: string }>();
  const [isLoading, setLoadStatus] = React.useState<boolean>(false);
  const { threads } = useThreadQuery();
  const { storeThread } = useMutationThreads();
  const threadId = params?.threadId ? params?.threadId : THREAD_ID;
  const thread = threads[threadId];

  const embedBlock = React.useMemo(
    () =>
      thread?.content[0] as unknown as Moim.Blockit.V2.IEmbedBlock | undefined,
    [thread],
  );

  React.useEffect(() => {
    setLoadStatus(true);

    connectTo(MATCH_FORUM_ID, GROUP_ID, {
      postId: threadId,
    });

    fetchThread(threadId)
      .then(threadDatum => {
        storeThread(threadDatum);
      })
      .finally(() => {
        setLoadStatus(false);
      });

    return () => {
      disconnect();
    };
  }, [threadId]);

  if (!thread) {
    if (isLoading) {
      return <div>Thread fetching...</div>;
    }
    return <div>Thread not found</div>;
  }

  if (!embedBlock) {
    return <div>this thread doesn't contain Embedding block.</div>;
  }

  return (
    <IFrame
      content={embedBlock.content}
      script={embedBlock.script}
      css={embedBlock.css}
      embedObject={(thread as any).embedObject}
    />
  );
};

export default function ConnectedMatchPage() {
  return (
    <ChannelEventProvider>
      <MatchPage />
    </ChannelEventProvider>
  );
}
